// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__AS0P8","amount":"Amount_amount__11f4x","tip":"Amount_tip__3aKta","tipHeader":"Amount_tipHeader__3FTRH","tipsWrap":"Amount_tipsWrap__2woJa"};